import axios from 'axios';
import { QuotationResponseType } from '../enums';
import {
  StartOrderRequest,
  StartOrderResponse,
  QuotationRequest,
  QuotationResponse,
} from 'type';
import { CREATE_QUOTATION, START_ORDER } from './constants';

/**
 * Function to submit order for quotation creation.
 */
export const createQuotation = (quotationRequest: QuotationRequest) => {
  return new Promise((resolve, reject) => {
    axios
      .post<null, QuotationResponse>(CREATE_QUOTATION(), quotationRequest)
      .then((res) => {
        resolve(res.data.quoteId);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          reject(QuotationResponseType.mustLogin);
        } else if (
          error.response.status === 403 &&
          error.response.data.error === 'Your email must be verified'
        ) {
          reject(QuotationResponseType.activateEmail);
        } else {
          reject(QuotationResponseType.UnknownError);
        }
      });
  });
};
/**
 * Function to submit quotation to place order
 */
export const startOrder = (startOrderRequest: StartOrderRequest) => {
  return new Promise((resolve, reject) => {
    axios
      .get<number, StartOrderResponse>(START_ORDER(startOrderRequest))
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          reject(QuotationResponseType.mustLogin);
        } else if (
          error.response.status === 403 &&
          error.response.data.error === 'Your email must be verified'
        ) {
          reject(QuotationResponseType.activateEmail);
        } else {
          reject(QuotationResponseType.UnknownError);
        }
      });
  });
};
